/**
 * DEV-3346-BAKIYE — "Yenile" onay diyaloğunun bakiye isteği için KISA MEMO.
 *
 * NEDEN VAR: `UcretliSorguOnayDialog` her açılışında `SorguBakiyesi().run(...)`
 * ile UYAP'a CANLI istek atıyordu — kullanıcı diyaloğu açıp "Vazgeç" dese bile
 * istek gitmiş oluyordu. Formda 5 rozet var; kullanıcı açıp kapadıkça her
 * seferinde bir UYAP isteği (bakiye ücretsiz ama UYAP trafiği ve 1 sn tempo
 * boşa harcanıyor).
 *
 * KORUMA KORUNUR: diyalog açılınca hak durumu yine sorulur (onay belirsizlikte
 * verilmesin). Ama aynı dosyaId için `BAKIYE_MEMO_OMRU_MS` içindeki İKİNCİ
 * açılış UYAP'a gitmez, bu memo'daki cevabı gösterir.
 *
 * Memo, kullanıcı GERÇEKTEN "Yenile"yi onaylayıp ücretli sorgu koştuğunda o
 * dosya için `gecersizKil` ile GEÇERSİZ kılınır — hak sayısı o koşumda
 * değişmiş olabilir, bir daha eski cevap gösterilmez.
 *
 * Hata/boş cevap memo'ya YAZILMAZ (çağıran taraf, `yaz`ı yalnız gerçek bir
 * cevap aldığında çağırır) — böylece "sorulamadı" durumu "hak var" gibi
 * önbelleğe düşmez.
 *
 * `simdiMs` parametreli: modül `Date.now()`a bağımlı değil, üretimde çağıran
 * `Date.now()` geçer; testler sabit zaman damgalarıyla çalışır.
 */

/** Memo'nun geçerli sayıldığı süre. */
export const BAKIYE_MEMO_OMRU_MS = 60_000;

interface BakiyeMemoKaydi {
    bakiye: any;
    yazildigiMs: number;
}

/** Dosya başına tek kayıt; modül seviyesinde (uygulama ömrü boyunca) tutulur. */
const memo = new Map<string, BakiyeMemoKaydi>();

function anahtar(dosyaId: string | number): string {
    return String(dosyaId);
}

/**
 * Dosya için geçerli bir memo varsa bakiyeyi döner; yoksa/süresi dolduysa
 * `undefined` döner (süresi dolan kayıt burada silinir).
 */
export function oku(dosyaId: string | number, simdiMs: number): any {
    const k = anahtar(dosyaId);
    const kayit = memo.get(k);
    if (!kayit) {
        return undefined;
    }

    if (simdiMs - kayit.yazildigiMs >= BAKIYE_MEMO_OMRU_MS) {
        memo.delete(k);
        return undefined;
    }

    return kayit.bakiye;
}

/** UYAP'tan gerçekten alınmış bir cevabı dosya için memo'ya yazar. */
export function yaz(dosyaId: string | number, bakiye: any, simdiMs: number): void {
    memo.set(anahtar(dosyaId), {bakiye, yazildigiMs: simdiMs});
}

/** Kullanıcı ücretli sorguyu onayladığında o dosyanın memo'sunu düşürür. */
export function gecersizKil(dosyaId: string | number): void {
    memo.delete(anahtar(dosyaId));
}
